export const urlApiCRM = {
    getCRMListView: '/api/customers/crm/list',
    createLead: '/api/leads/',
    getClientDetails: '/api/customers/crm',
    getDocuments: '/api/customers/crm',
    uploadFile: '/api/customers/crm',
    createCustomer: '/api/customers/create',
    updateCustomer: (id: string) => `/api/customers/${id}`,
};

export const urlApiJobs = {
    getBoardCount: '/api/jobs/count/board',
    getJobs: '/api/jobs',
    addJob: '/api/jobs',
};

export const urlApiJobDetails = {
    getJobDetails: (id: string) => `/api/jobs/${id}/sidebar`,
    getOverviewJobDetails: (id: string) => `/api/jobs/${id}/job-details`,
    getOverviewCustomerDetails: (id: string) => `/api/jobs/${id}/customer-details`,
    updateOverviewCustomerDetails: (id: string) => `/api/customers/${id}`,
    getOverviewActivityFeed: (id: string) => `/api/jobs/${id}/activity-feed`,
    updateOverviewJobDetails: (id: string) => `/api/jobs/${id}`,
    addAssignees: (id: string) => `/api/jobs/${id}/team-members`,
    getJobDocuments: (id: string) => `/api/jobs/${id}/job-documents`,
    createJobDocument: '/api/job-documents/create',
    deleteJobDocument: (id: string) => `/api/job-documents/${id}`,
    downloadAllJobDocuments: (id: string) => `/api/jobs/${id}/job-documents/download-all`,
    downloadJobDocument: (id: string, documentId: string) => `/api/jobs/${id}/job-documents/${documentId}/download`,
    addNote: (id: string) => `/api/jobs/${id}/notes`,
    getMaterialOrders: (id: string) => `/api/jobs/${id}/materials`,
    createMaterialOrder: (id: string) => `/api/jobs/${id}/materials`,
    createMaterialOrderDraft: (id: string) => `/api/jobs/${id}/materials/draft`,
    getMaterialOrder: (id: string, materialId: string) => `/api/jobs/${id}/materials/${materialId}`,
    updateMaterialOrder: (id: string, materialId: string) => `/api/jobs/${id}/materials/${materialId}`,
    updateMaterialOrderDraft: (id: string, materialId: string) => `/api/jobs/${id}/materials/${materialId}/draft`,
    deleteMaterialOrder: (id: string, orderId: string) => `/api/jobs/${id}/material-orders/${orderId}`,
    searchBranches: (stateCode: string) => `/api/abc/branches/search?state=${stateCode}`,
    searchProducts: (branchNumber: string, description: string) => `/api/abc/product/search?branchNumber=${branchNumber}&description=${description}`,
    getProductPricing: '/api/abc/product/pricing',
    getOverviewWorkOrderDetails: (id: string) => `/api/work-orders/${id}`,
    getOverviewWorkOrderList: '/api/work-orders',
    createWorkOrder: '/api/work-orders',
    updateWorkOrder: (id: string) => `/api/work-orders/${id}`,
    deleteWorkOrder: (id: string) => `/api/work-orders/${id}`,
    exportWorkOrderPDF: (id: string) => `/api/work-orders/export-pdf/${id}`,
    exportWorkOrderPDFFromHTML: '/api/work-orders/export-pdf-from-html',
    jobDetailsAddContact: (id: string) => `/api/jobs/${id}/add-contact`,
    getOverviewJobTaskList: (id: string) => `/api/jobs/${id}/tasks`,
    createJobTask: '/api/tasks/create',
    updateJobTask: (id: string) => `/api/tasks/${id}`,
    getInvoiceJobDetailsList: (id: string) => `/api/jobs/${id}/invoices`,
    updateStatusInvoiceJobDetails: (idJob: string, idInvoice: string) => `/api/jobs/${idJob}/invoices/${idInvoice}/status`,
    createInvoice: (jobId: string) => `/api/jobs/${jobId}/invoices`,
    getListProductInvoice: (jobId: string) => `/api/jobs/${jobId}/list-products`,
    getInvoiceTaxRates: (jobId: string) => `/api/jobs/${jobId}/tax-rates`,
    getInvoiceDetailsJobDetails: (idJob: string, idInvoice: string) => `/api/jobs/${idJob}/invoices/${idInvoice}`,
    getListPaymentInFinancialTab: (idJob: string) => `/api/jobs/${idJob}/payments`,
    getListBudgetTrackerJobDetails: (idJob: string) => `/api/jobs/${idJob}/budget-trackers`,
    createStripeCheckout: (invoiceId: string) => `/api/stripe/invoices/${invoiceId}/checkout`,
    getPaymentHistories: '/api/stripe/payment-histories',
    getListCreditMemoJobDetails: (idJob: string) => `/api/jobs/${idJob}/credit-memos`,
    getItemCreateNewBudget: (idJob: string, idEstimate: string) => `/api/jobs/${idJob}/budget-trackers/estimate/${idEstimate}/items`,
    createNewBudget: (idJob: string) => `/api/jobs/${idJob}/budget-trackers`,
    getDetailsBudgetTrackerJobDetails: (idJob: string, idBudget: string) => `/api/jobs/${idJob}/budget-trackers/${idBudget}`,
    createFinanceActivityLog: (idJob: string) => `/api/jobs/${idJob}/finance-activity-logs`,
    markPaymentAsPaid: (idJob: string, idBudget: string, idCommission: string) => `/api/jobs/${idJob}/budget-trackers/${idBudget}/mark-paid/${idCommission}`,
    createCreditMemo: (idJob: string) => `/api/jobs/${idJob}/credit-memos`,
    getCreditMemoDetailsJobDetails: (idJob: string, idCreditMemo: string) => `/api/jobs/${idJob}/credit-memos/${idCreditMemo}`,
    getInvoiceInViewInvoice: (idInvoice: string) => `/api/job-invoices/${idInvoice}/view`,
    getPublicInvoice: (token: string) => `/api/job-invoices/public/${token}`,
    createPublicCheckout: (token: string) => `/api/job-invoices/public/${token}/checkout`,
    emailInvoice: '/api/integrations/google/gmail/send-invoice',
    getListInvoiceInLogPaymentModal: (idJob: string) => `/api/jobs/${idJob}/payments/invoices`,
    logPayment: (idJob: string) => `/api/jobs/${idJob}/payments`,
    deletePayment: (idJob: string, idPayment: string) => `/api/jobs/${idJob}/payments/${idPayment}`,
    createPaymentRequest: (idJob: string) => `/api/jobs/${idJob}/payment-requests`,
    toggleArchivedBudgetTracker: (idJob: string, idBudget: string) => `/api/jobs/${idJob}/budget-trackers/${idBudget}/is-archived`,
};

export const urlApiReport = {
    getClosedInvoices: '/api/dashboard/closed-invoices',
    getMyTasks: '/api/dashboard/my-tasks',
    getInvoiceOpenSalesRep: '/api/dashboard/invoice-open-sales-rep',
    getPaidAndLeftReview: '/api/dashboard/paid-and-left-review',
    getPayments: '/api/dashboard/payments',
    getMyPayments: '/api/dashboard/my-payments',
    getInvoiceOpen: '/api/dashboard/invoice-opens',
    getInvoiceListing: '/api/dashboard/invoice-listings',
    getJobInProgressCompleted: '/api/dashboard/jobs-in-progress-completeds',
    getRoofs: '/api/dashboard/roofs',
    getShelbyvilleJob: '/api/dashboard/shelbyville-job',
    getShingleColor: '/api/dashboard/shingle-colors',
    getShingle: '/api/dashboard/shingles',
    getInsights: '/api/dashboard/insights',
};

export const urlApiEstimateSetting = {
    getEstimateLayout: '/api/estimates/estimate-layouts',
    createEstimateLayout: '/api/estimates/create-estimate-layout',
    getEstimateTemplate: '/api/estimate-templates',
    createIntroductionTemplate: '/api/estimate-templates/introduction',
    createDetailsTemplate: '/api/estimate-templates/details',
    signingUpgrades: '/api/estimate-templates/authorization',
    getEstimateTemplateIntroduction: '/api/estimate-templates/introduction',
    getEstimateTemplateAuthorization: '/api/estimate-templates/authorization'
};